import Vue from 'vue';
import './element';

import CommonTable from '@/components/CommonTable';
import CodeDomainSelect from '@/components/CodeDomainSelect'
import AutoComplate from '@/components/AutoComplate'

Vue.component('common-table', CommonTable);
Vue.component('code-domain-select', CodeDomainSelect);
Vue.component('code-autocomplate', AutoComplate);